import type { ReactNode } from 'react';

export const symbol_mobiledata_arrows: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M318-236v-312q0-13 8.5-21.5T348-578q13 0 21.5 8.5T378-548v312l58-58q9-9 21.5-9t21.5 9q9 9 9 21.5t-9 21.5L369-141q-9 9-21 9t-21-9L217-251q-9-9-8.5-21.5T218-294q9-9 21.5-9t21.5 9l57 58Zm253-488-58 58q-9 9-21 8.5t-21-9.5q-9-9-9-21.5t9-21.5l109-109q9-9 21-9t21 9l110 110q9 9 9 21t-9 21q-9 9-21.5 9t-21.5-9l-58-57v323q0 13-8.5 21.5T601-371q-13 0-21.5-8.5T571-401v-323Z"
		/>
	</svg>
);
